<template>
  <div :class="['v-alert', alertVariant]" role="alert">
    <slot />
  </div>
</template>

<script>
const variants = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  DANGER: "danger",
  WARNING: "warning",
  INFO: "info"
});

export default {
  name: "BaseAlert",
  props: {
    variant: {
      type: String,
      validator: value => Object.values(variants).includes(value),
      default: variants.PRIMARY
    }
  },
  computed: {
    alertVariant() {
      return `v-alert-${this.variant}`;
    }
  }
};
</script>
